/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/prefer-default-export */
import { useTranslation } from 'react-i18next';
import { useSafeAuth } from '@app/hooks/use-safe-auth';
import { getNativeAuthBridge } from '@app/utils/native-auth-bridge';
import { shouldUseNativeAuth } from '@app/helpers/platform';
import { resetZendeskWidget } from '@app/helpers/zendesk/zendesk-widget';
import { Button } from '@chakra-primitives/button';
import { NAMESPACE } from '@app/i18n';
import { clearStoredLocale } from '@app/i18n/stored-locale';

export const Logout = () => {
  const { oktaAuth } = useSafeAuth();
  const { t } = useTranslation(NAMESPACE.APP_SHELL);

  const logout = async () => {
    clearStoredLocale();
    await resetZendeskWidget();

    if (shouldUseNativeAuth()) {
      // For native auth: use the bridge to sign out
      try {
        const nativeBridge = getNativeAuthBridge();
        await nativeBridge.signOut();
      } catch (error) {
        console.error('Native auth logout failed:', error);
        // Fallback to web auth logout
        oktaAuth.signOut('/');
      }
    } else {
      // For web auth: use standard oktaAuth client
      oktaAuth.signOut('/');
    }
  };

  return (
    <Button className="home-button" onClick={logout}>
      {t('error.backToLogin')}
    </Button>
  );
};
